

import axios from 'axios';
import { API_KEY, BASE_URL, getAxiosConfig } from '../../components/interface/Config';

const API_URL = `${BASE_URL}/resource/patientHealth`;

export const fetchDiets = async (token: string,params: Record<string, any>) => {
    try {
        console.log("444$$$$$$$$$$$$$$$$$$$$$$$$$",token);
        const response = await axios.get<{ data: { patient_healths: any[], pagination: { total: number } } }>(API_URL, {
            params,
            headers: getAxiosConfig().headers
        });
        return response.data;
    } catch (error) {
        throw new Error('Failed to fetch diet.');
    }
};


